import comp from "./SelectDropdown";

export { default as FormSelectDropdown } from "./FormSelectDropdown";
export default comp;
